import { EmergencyContacts } from "@EspaceParkQC/sdk-call-center";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@EspaceParkQC/sdk-react";
import { Contact, MailIcon, PhoneIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Contacts(): React.ReactElement {
  const { t } = useTranslation("main");

  return (
    <Card className="w-full md:min-w-md">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Contact className="size-5" />
          {t("intercom.contacts.title")}
        </CardTitle>
        <CardDescription>{t("intercom.contacts.description")}</CardDescription>
      </CardHeader>
      <CardContent>
        <EmergencyContacts
          render={({ contacts }) => {
            if (!contacts || contacts.length === 0) {
              return (
                <div className="flex items-center justify-center h-32 rounded-lg border border-dashed bg-muted/50">
                  <p className="text-sm text-muted-foreground">{t("intercom.contacts.no-contacts-available")}</p>
                </div>
              );
            }

            return (
              <ul className="divide-y divide-border">
                {contacts.map((contact, index) => (
                  <li key={index} className="space-y-1.5 py-4 first:pt-0 last:pb-0">
                    <p className="font-medium text-sm">{contact.name}</p>
                    {contact.phone && (
                      <p className="text-xs text-muted-foreground flex gap-2 items-center">
                        <PhoneIcon className="size-3" /> {contact.phone}
                      </p>
                    )}
                    {contact.email && (
                      <p className="text-xs text-muted-foreground flex gap-2 items-center">
                        <MailIcon className="size-3" /> {contact.email}
                      </p>
                    )}
                  </li>
                ))}
              </ul>
            );
          }}
        />
      </CardContent>
    </Card>
  );
}
